// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"YP-z","inlineTitle":"ZP-z","sponsoredAdsWrapper":"_P-z","marketplaceRecosWrapper":"aQ-z"};